import { PublicPlansConfiguration } from '@telialt/core-plans/src/model';

import { BlockWidgetType } from '../../models/Content';

export type WidgetType = BlockWidgetType['fields']['type'];

export type BlockWidgetData = {
    type: WidgetType;
    configuration?: any;
    relatedContent?: BlockWidgetType['fields']['relatedContent'];
};

export interface BlockWidgetFeedbackFormData extends BlockWidgetData {
    type: 'FeedbackForm';
    configuration: unknown;
}

export interface BlockWidgetSpeedTestData extends BlockWidgetData {
    type: 'SpeedTest';
    configuration: unknown;
}

export type OfferGroup = 'MHS' | 'MBB';

export interface BlockWidgetPlansListData extends BlockWidgetData {
    type: 'PlansList';
    configuration: PublicPlansConfiguration;
}

export interface BlockWidgetCoverageMapData extends BlockWidgetData {
    type: 'CoverageMap';
    configuration?: unknown;
}

export const isBlockWidgetTypeCoverageMap = (
    blockWidget: BlockWidgetData,
): blockWidget is BlockWidgetCoverageMapData => {
    return blockWidget.type === 'CoverageMap';
};

export const isBlockWidgetTypeFeedbackForm = (
    blockWidget: BlockWidgetData,
): blockWidget is BlockWidgetFeedbackFormData => {
    return blockWidget.type === 'FeedbackForm';
};

export const isBlockWidgetTypePlansList = (blockWidget: BlockWidgetData): blockWidget is BlockWidgetPlansListData => {
    return blockWidget.type === 'PlansList';
};

export const isBlockWidgetTypeSpeedTest = (blockWidget: BlockWidgetData): blockWidget is BlockWidgetSpeedTestData => {
    return blockWidget.type === 'SpeedTest';
};
